var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 213.598,
    height: 85.011,
    viewBox: "0 0 213.598 85.011",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_14549",
    x: 0,
    y: 0,
    width: 60.265,
    height: 79.036,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_14547",
    x: 0.969,
    y: 51.407,
    width: 95.706,
    height: 33.605,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_14548",
    x: 50.052,
    y: 0.058,
    width: 47.278,
    height: 78.557,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5072",
    "data-name": "Group 5072",
    transform: "translate(-39.548 -31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5070",
    "data-name": "Group 5070",
    transform: "translate(0 -5.53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14545",
    "data-name": "Path 14545",
    d: "M3.4,0V-3.216l.285.744L-.048-8.4H1.28l3.139,5H3.7l3.152-5H8.079L4.357-2.472l.273-.744V0Zm9.48.1a5.13,5.13,0,0,1-1.843-.324,4.427,4.427,0,0,1-1.47-.906A4.182,4.182,0,0,1,8.6-2.5a4.14,4.14,0,0,1-.347-1.7A4.14,4.14,0,0,1,8.6-5.9a4.182,4.182,0,0,1,.968-1.362,4.44,4.44,0,0,1,1.464-.906A5.116,5.116,0,0,1,12.881-8.5a5.115,5.115,0,0,1,1.83.318,4.445,4.445,0,0,1,1.464.9,4.062,4.062,0,0,1,.968,1.362A4.235,4.235,0,0,1,17.484-4.2a4.235,4.235,0,0,1-.341,1.716,4.062,4.062,0,0,1-.968,1.362,4.445,4.445,0,0,1-1.464.9A5.115,5.115,0,0,1,12.881.1Zm0-1.068a3.633,3.633,0,0,0,1.334-.24,3.182,3.182,0,0,0,1.067-.678,3.154,3.154,0,0,0,.707-1.026A3.2,3.2,0,0,0,16.243-4.2a3.2,3.2,0,0,0-.254-1.284,3.154,3.154,0,0,0-.707-1.026,3.182,3.182,0,0,0-1.067-.678,3.633,3.633,0,0,0-1.334-.24,3.668,3.668,0,0,0-1.346.24,3.251,3.251,0,0,0-1.073.678,3.109,3.109,0,0,0-.713,1.026A3.2,3.2,0,0,0,9.494-4.2a3.2,3.2,0,0,0,.254,1.284,3.109,3.109,0,0,0,.713,1.026,3.251,3.251,0,0,0,1.073.678A3.668,3.668,0,0,0,12.881-.972ZM22.981.1a3.71,3.71,0,0,1-2.692-.948,3.683,3.683,0,0,1-.98-2.772V-8.4h1.241v4.728a2.831,2.831,0,0,0,.639,2.052,2.422,2.422,0,0,0,1.805.648,2.439,2.439,0,0,0,1.818-.648,2.831,2.831,0,0,0,.639-2.052V-8.4h1.2v4.776a3.7,3.7,0,0,1-.974,2.772A3.706,3.706,0,0,1,22.981.1ZM29.2,0V-8.4h1.017l5.745,6.9h-.534V-8.4h1.241V0H35.649L29.9-6.9h.534V0Zm14,.1a5.2,5.2,0,0,1-1.849-.318,4.362,4.362,0,0,1-1.464-.9,4.182,4.182,0,0,1-.968-1.362A4.17,4.17,0,0,1,38.565-4.2a4.17,4.17,0,0,1,.347-1.716,4.139,4.139,0,0,1,.974-1.362,4.431,4.431,0,0,1,1.47-.9A5.239,5.239,0,0,1,43.218-8.5a5.289,5.289,0,0,1,1.886.324,3.736,3.736,0,0,1,1.452.972l-.769.744a3.436,3.436,0,0,0-1.16-.738,3.853,3.853,0,0,0-1.359-.234,3.9,3.9,0,0,0-1.383.24,3.316,3.316,0,0,0-1.1.672,2.989,2.989,0,0,0-.72,1.026,3.242,3.242,0,0,0-.254,1.29,3.212,3.212,0,0,0,.254,1.278,3.051,3.051,0,0,0,.72,1.032,3.278,3.278,0,0,0,1.1.678,3.853,3.853,0,0,0,1.377.24,4.245,4.245,0,0,0,1.334-.21,3.3,3.3,0,0,0,1.185-.7l.707.912a4.453,4.453,0,0,1-1.508.8A5.924,5.924,0,0,1,43.193.1Zm2.1-1.224v-3.12h1.191V-.972ZM52.189,0V-8.4h3.387a4.9,4.9,0,0,1,1.948.348,2.737,2.737,0,0,1,1.241,1.008A2.8,2.8,0,0,1,59.2-5.472a2.766,2.766,0,0,1-.434,1.566A2.789,2.789,0,0,1,57.524-2.9a4.832,4.832,0,0,1-1.948.354h-2.7l.558-.564V0Zm1.241-2.988-.558-.6h2.668a2.839,2.839,0,0,0,1.805-.492,1.681,1.681,0,0,0,.614-1.392,1.681,1.681,0,0,0-.614-1.392,2.839,2.839,0,0,0-1.805-.492H52.871l.558-.6Zm8.723-1.788h4.467v1.02H62.152Zm.112,3.732h5.062V0h-6.3V-8.4h6.129v1.044H62.264ZM73.245.1A5.13,5.13,0,0,1,71.4-.228a4.427,4.427,0,0,1-1.47-.906A4.182,4.182,0,0,1,68.964-2.5a4.14,4.14,0,0,1-.347-1.7,4.14,4.14,0,0,1,.347-1.7,4.182,4.182,0,0,1,.968-1.362A4.441,4.441,0,0,1,71.4-8.172,5.116,5.116,0,0,1,73.245-8.5a5.115,5.115,0,0,1,1.83.318,4.445,4.445,0,0,1,1.464.9,4.062,4.062,0,0,1,.968,1.362A4.235,4.235,0,0,1,77.848-4.2a4.235,4.235,0,0,1-.341,1.716,4.062,4.062,0,0,1-.968,1.362,4.445,4.445,0,0,1-1.464.9A5.115,5.115,0,0,1,73.245.1Zm0-1.068a3.633,3.633,0,0,0,1.334-.24,3.182,3.182,0,0,0,1.067-.678,3.154,3.154,0,0,0,.707-1.026A3.2,3.2,0,0,0,76.607-4.2a3.2,3.2,0,0,0-.254-1.284,3.154,3.154,0,0,0-.707-1.026,3.182,3.182,0,0,0-1.067-.678,3.633,3.633,0,0,0-1.334-.24,3.668,3.668,0,0,0-1.346.24,3.251,3.251,0,0,0-1.073.678,3.109,3.109,0,0,0-.713,1.026A3.2,3.2,0,0,0,69.857-4.2a3.2,3.2,0,0,0,.254,1.284,3.109,3.109,0,0,0,.713,1.026,3.251,3.251,0,0,0,1.073.678A3.668,3.668,0,0,0,73.245-.972Zm6.5.972V-8.4h3.387a4.9,4.9,0,0,1,1.948.348,2.737,2.737,0,0,1,1.241,1.008,2.8,2.8,0,0,1,.434,1.572,2.766,2.766,0,0,1-.434,1.566A2.789,2.789,0,0,1,85.081-2.9a4.831,4.831,0,0,1-1.948.354h-2.7l.558-.564V0Zm1.241-2.988-.558-.6H83.1A2.839,2.839,0,0,0,84.9-4.08a1.681,1.681,0,0,0,.614-1.392A1.681,1.681,0,0,0,84.9-6.864,2.839,2.839,0,0,0,83.1-7.356H80.429l.558-.6ZM88.58,0V-8.4h1.241v7.356h4.7V0Zm8.5-4.776h4.467v1.02H97.08Zm.112,3.732h5.062V0h-6.3V-8.4h6.129v1.044H97.191Zm6.427-4.584.62-2.436.161.7a.87.87,0,0,1-.6-.216.734.734,0,0,1-.242-.576.767.767,0,0,1,.242-.594.84.84,0,0,1,.589-.222.769.769,0,0,1,.583.234.81.81,0,0,1,.223.582,2.052,2.052,0,0,1-.012.222,1.45,1.45,0,0,1-.056.258q-.043.144-.13.372l-.6,1.68ZM109.736.1a6.11,6.11,0,0,1-1.9-.294A3.927,3.927,0,0,1,106.41-.96l.459-.936a4.066,4.066,0,0,0,1.266.7,4.7,4.7,0,0,0,1.6.276,3.732,3.732,0,0,0,1.228-.168,1.458,1.458,0,0,0,.695-.462,1.073,1.073,0,0,0,.223-.666.894.894,0,0,0-.292-.7,2.181,2.181,0,0,0-.757-.426,8.641,8.641,0,0,0-1.024-.282q-.558-.12-1.123-.282a5.122,5.122,0,0,1-1.03-.414A2.08,2.08,0,0,1,106.907-5a1.936,1.936,0,0,1-.285-1.1,2.153,2.153,0,0,1,.354-1.194,2.438,2.438,0,0,1,1.092-.876,4.627,4.627,0,0,1,1.88-.33,5.989,5.989,0,0,1,1.5.192,4.257,4.257,0,0,1,1.29.552l-.409.96a4.056,4.056,0,0,0-1.179-.522,4.756,4.756,0,0,0-1.2-.162,3.416,3.416,0,0,0-1.2.18,1.465,1.465,0,0,0-.689.48,1.119,1.119,0,0,0-.217.672.908.908,0,0,0,.292.708,2.112,2.112,0,0,0,.757.42,10.5,10.5,0,0,0,1.024.282q.558.126,1.123.282a4.889,4.889,0,0,1,1.03.408,2.1,2.1,0,0,1,.751.672,1.883,1.883,0,0,1,.285,1.08,2.107,2.107,0,0,1-.36,1.182,2.473,2.473,0,0,1-1.11.876A4.718,4.718,0,0,1,109.736.1Z",
    transform: "translate(140.048 70.506)",
    fill: "#101744"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14546",
    "data-name": "Path 14546",
    d: "M5.368,0V-13.486H.088V-15.4H12.826v1.914H7.546V0Zm9.856,0V-15.4H21.23a8.445,8.445,0,0,1,3.454.638,4.891,4.891,0,0,1,2.2,1.848,5.254,5.254,0,0,1,.77,2.882,5.2,5.2,0,0,1-.77,2.871,4.915,4.915,0,0,1-2.2,1.837,8.445,8.445,0,0,1-3.454.638h-4.8l.99-1.012V0Zm10.3,0L21.6-5.588h2.354L27.918,0Zm-8.1-5.478-.99-1.078h4.73a4.872,4.872,0,0,0,3.2-.913,3.16,3.16,0,0,0,1.089-2.563,3.128,3.128,0,0,0-1.089-2.552,4.914,4.914,0,0,0-3.2-.9h-4.73l.99-1.1ZM31.218,0V-15.4h2.2V0Zm4.488,0L42.68-15.4h2.178l7,15.4h-2.31L43.318-14.168h.88L37.972,0Zm2.97-3.85.594-1.76h8.668l.638,1.76ZM54.142,0V-15.4h1.8L66.132-2.75h-.946V-15.4h2.2V0h-1.8L55.4-12.65h.946V0ZM78.958.176A8.953,8.953,0,0,1,75.68-.407a7.7,7.7,0,0,1-2.6-1.65,7.669,7.669,0,0,1-1.716-2.5A7.869,7.869,0,0,1,70.752-7.7a7.869,7.869,0,0,1,.616-3.146,7.588,7.588,0,0,1,1.727-2.5,7.817,7.817,0,0,1,2.607-1.65,9.016,9.016,0,0,1,3.3-.583,9.1,9.1,0,0,1,3.344.594A6.616,6.616,0,0,1,84.92-13.2l-1.364,1.364A6.07,6.07,0,0,0,81.5-13.189a6.631,6.631,0,0,0-2.409-.429,6.718,6.718,0,0,0-2.453.44,5.849,5.849,0,0,0-1.958,1.232A5.483,5.483,0,0,0,73.4-10.065,6.12,6.12,0,0,0,72.952-7.7,6.062,6.062,0,0,0,73.4-5.357a5.6,5.6,0,0,0,1.276,1.892,5.785,5.785,0,0,0,1.947,1.243,6.631,6.631,0,0,0,2.442.44,7.3,7.3,0,0,0,2.365-.385,5.821,5.821,0,0,0,2.1-1.287l1.254,1.672A7.813,7.813,0,0,1,82.115-.319,10.186,10.186,0,0,1,78.958.176Zm3.718-2.244v-5.72h2.112v6.006ZM88.99,0V-15.4h2.2V-1.914h8.338V0Zm15.07-8.756h7.92v1.87h-7.92Zm.2,6.842h8.976V0H102.058V-15.4h10.868v1.914h-8.668Z",
    transform: "translate(139.912 95.506)",
    fill: "#101744"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5071",
    "data-name": "Group 5071",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14549-2",
    "data-name": "Path 14549",
    d: "M683.4,1428.677v21.983a9.43,9.43,0,1,1,0,17.473v12.308l-5.814,3.357q-.139-.274-.294-.544a11.057,11.057,0,0,0-19.152,11.057q.156.27.324.527l-22.329,12.874a7.007,7.007,0,0,1,.945-3.958l43-72.362a6.054,6.054,0,0,1,1.573-1.824,5.281,5.281,0,0,1,1.743-.892",
    transform: "translate(-596.573 -1397.677)",
    fill: "#f07b3f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 39.55, 31)",
    filter: "url(#Path_14549)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14549-3",
    "data-name": "Path 14549",
    d: "M683.4,1428.677v21.983a9.43,9.43,0,1,1,0,17.473v12.308l-5.814,3.357q-.139-.274-.294-.544a11.057,11.057,0,0,0-19.152,11.057q.156.27.324.527l-22.329,12.874a7.007,7.007,0,0,1,.945-3.958l43-72.362a6.054,6.054,0,0,1,1.573-1.824,5.281,5.281,0,0,1,1.743-.892",
    transform: "translate(-636.12 -1428.68)",
    fill: "#fff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14547-2",
    "data-name": "Path 14547",
    d: "M744.877,2150.985l-21.366-12.08q-.2.406-.424.8a11.97,11.97,0,1,1-20.733-11.97q.229-.4.483-.768l-5.97-3.447-8.418,4.86a8.711,8.711,0,1,0-13.913,8.033l-25.365,15.161a6.016,6.016,0,0,0,1.5,1.695,5.1,5.1,0,0,0,3.128,1.089v.006h86.136a5.553,5.553,0,0,0,4.946-3.381",
    transform: "translate(-608.653 -2038.354)",
    fill: "#2d4059",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 39.55, 31)",
    filter: "url(#Path_14547)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14547-3",
    "data-name": "Path 14547",
    d: "M744.877,2150.985l-21.366-12.08q-.2.406-.424.8a11.97,11.97,0,1,1-20.733-11.97q.229-.4.483-.768l-5.97-3.447-8.418,4.86a8.711,8.711,0,1,0-13.913,8.033l-25.365,15.161a6.016,6.016,0,0,0,1.5,1.695,5.1,5.1,0,0,0,3.128,1.089v.006h86.136a5.553,5.553,0,0,0,4.946-3.381",
    transform: "translate(-648.2 -2069.35)",
    fill: "#fff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14548-2",
    "data-name": "Path 14548",
    d: "M1357.249,1508.02l-23.424-13.078a9.43,9.43,0,1,1-15.087-8.71l-8.767-5.062v-9.1q.388.025.782.025a11.97,11.97,0,1,0,0-23.941q-.394,0-.782.025l.178-18.715a5.675,5.675,0,0,1,3.07,2.552l42.913,72.208a6.938,6.938,0,0,1,1.117,3.8",
    transform: "translate(-1220.37 -1398.405)",
    fill: "#ffd460",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 39.55, 31)",
    filter: "url(#Path_14548)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14548-3",
    "data-name": "Path 14548",
    d: "M1357.249,1508.02l-23.424-13.078a9.43,9.43,0,1,1-15.087-8.71l-8.767-5.062v-9.1q.388.025.782.025a11.97,11.97,0,1,0,0-23.941q-.394,0-.782.025l.178-18.715a5.675,5.675,0,0,1,3.07,2.552l42.913,72.208a6.938,6.938,0,0,1,1.117,3.8",
    transform: "translate(-1259.92 -1429.41)",
    fill: "#fff",
    fillRule: "evenodd"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fc3da94ecdf32a5595280d4b83d76e31.svg";
export { ForwardRef as ReactComponent };